<template>
	<basic-container v-loading="isInitLoading" :block="isInitLoading">
		<div v-if="!isInitLoading">
			<el-steps :active="getCurrentStep" align-center finish-status="success" show-icon>
				<el-step :title="ReplaceContent.choiceTitle"></el-step>
				<el-step :title="ReplaceContent.fillEmp"></el-step>
				<el-step title="完成"></el-step>
			</el-steps>

			<el-tabs v-model="stepActive" style="margin-top: 20px">
				<el-tab-pane label="" name="0">
					<el-card :header="ReplaceContent.choiceTitle">
						<template>
							<avue-crud
								ref="crud"
								:data="employeeList"
								:option="optionEmployeeEndorse"
								:page.sync="page"
								:table-loading="listLoading"
								@on-load="getEmployeeList"
								@search-change="searchChange"
								@search-reset="searchChange"
								@size-change="sizeChange"
								@current-change="currentChange"
								@selection-change="selectionChange">
								<template #menuRight="{}">
									<div v-if="isReplaceEmp === 0 && isShowMore" style="display: flex">
										<el-upload
											:auto-upload="false"
											:loading="listLoading"
											:on-change="onUploadTemp"
											:show-file-list="false"
											action="action"
											style="margin-left: 15px">
											<el-button icon="el-icon-upload2" type="primary">导入文件批量替换</el-button>
										</el-upload>
										<el-button :loading="listLoading" icon="el-icon-download" type="primary" @click="onDownload">
											模板
										</el-button>
									</div>
								</template>
								<template #menuLeft="{}">
									<div style="margin-top: 10px" v-if="isReplaceEmp === 0 && isShowMore">
										<el-tag size="mini" type="warning">替换人员一次最多替换20人</el-tag>
									</div>
								</template>
								<template #menu="{row, index}">
									<el-button icon="el-icon-sort" type="text" @click="handleReplaceSingle(row, index)">
										{{ ReplaceContent.choiceTi }}
									</el-button>
								</template>
							</avue-crud>
						</template>
					</el-card>
					<el-row justify="center" type="flex">
						<el-button
							:disabled="employeeSelectedList.length == 0 || employeeSelectedList.length > 20"
							type="primary"
							@click.native="handleStep2">
							下一步
						</el-button>
					</el-row>
				</el-tab-pane>
				<el-tab-pane label="" name="1">
					<el-card :header="ReplaceContent.fillEmp">
						<template>
							<avue-crud ref="crud" :data="employeeReplaceList" :option="optionEmployeeReplace">
								<template slot="header">
									<div style="display: flex; justify-content: space-between; margin-bottom: 10px; align-items: center">
										<el-tag size="small" type="warning">
											由于保险公司系统处理有延迟，最终承保生效时间请以保险公司系统为准
										</el-tag>
									</div>
								</template>
								<template slot="menu" slot-scope="scope">
									<el-button icon="el-icon-delete" type="text" @click="handleRemoveEmployee(scope.row, scope.index)">
										移除
									</el-button>
								</template>
							</avue-crud>
						</template>
					</el-card>

					<!--附件数据 formAttach-->
					<form-attach
						v-if="configData.attachForm"
						ref="refAttach"
						:attachFormAllData="configData.attachForm"
						class="u-m-b-20"></form-attach>

					<el-row justify="left" type="flex">
						<el-checkbox v-model="isNoticeRead">
							<span style="font-size: 16px; font-weight: bolder">我已知悉本次替换预计生效时间</span>
						</el-checkbox>
						<el-tag size="mini" type="danger">{{ effectiveDate }}零时</el-tag>
					</el-row>
					<el-row justify="center" type="flex">
						<el-button v-if="isShowMore" :loading="isShowLoading" type="primary" @click.native="handleStep1">
							上一步
						</el-button>
						<el-button
							:disabled="!isNoticeRead || employeeReplaceList.length == 0"
							:loading="isShowLoading"
							type="primary"
							@click.native="onHandleStep3Temp">
							{{ ReplaceContent.submit }}
						</el-button>
					</el-row>
				</el-tab-pane>
				<el-tab-pane label="" name="2">
					<el-row justify="center" type="flex">
						<avue-crud ref="crud" :data="employeeResultList" :option="optionEmployeeResult">
							<template v-if="!replaceSucceed" slot="header">
								<el-alert
									center
									show-icon
									style="margin-bottom: 10px"
									title="替换批单处理中，请不要关闭本页面，关闭将会导致剩余批单处理失败！"
									type="warning"></el-alert>
							</template>
							<template v-else slot="header">
								<el-alert
									center
									show-icon
									style="margin-bottom: 10px"
									title="替换批单处理成功！"
									type="success"></el-alert>
							</template>
							<!--                        <template slot="status" slot-scope="scope">-->
							<!--                            {{ scope.label }}-->
							<!--                        </template>-->
						</avue-crud>
					</el-row>
					<el-row justify="center" style="margin-top: 16px" type="flex">
						<el-button type="primary" @click.native="handleGoPolicy">返回保单</el-button>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</div>

		<base-form-dialog
			ref="hint_repeat_again"
			:formDataListTemp="repeatEmpList"
			btn-left-text="修改投保人员"
			btn-right-text="确认再次投保"
			width="50%"
			@onClickRight="onClickRight">
			<template slot="form_top">
				<span style="font-weight: bold">当前被保企业：{{ currentRepeatUnit }}</span>
				<el-alert
					:closable="false"
					style="margin: 10px 0; width: 100%"
					title="以下投保人员已通过其他企业投保，请确认是否需要再次投保？"
					type="warning"></el-alert>
			</template>
		</base-form-dialog>

		<base-form-dialog
			ref="hint_repeat"
			:formDataListTemp="allRepeatEmpList"
			btn-right-text="修改投保人员"
			form-option-num-temp="1"
			width="50%">
			<template slot="form_top">
				<span style="font-weight: bold; color: red">以下投保人员还未到期，不能替换</span>
			</template>
		</base-form-dialog>
	</basic-container>
</template>

<script>
import {
	checkIdNo,
	endorseReplace,
	fetchEmployeeList,
	fetchEmployeeListPage,
	getRepeatEmpList,
	getReplaceEffectiveDate,
	getReplaceResult,
} from '@/api/insurance/policy'
import BaseFormDialog from '@/components/insurance/baseFormDialog'
import {optionEmployeeEndorse, optionEmployeeReplace, optionEmployeeResult} from '@/const/crud/insurance/policy'
import {huisuAble} from '@/mixins/huisuAble'
import {MessageEventType, sendMsgToParent} from '@/util/channelUtil'
import {toYYYYmmddFullDate} from '@/util/date'
import {exportFileCommon} from '@/util/exportFile'
import {isIdCardNoValid} from '@/util/validateRules'
import {isJiaDian, isNoMoreReplace} from 'meibao-insure/src/util/productUtil'
import {mapGetters} from 'vuex'
import {getInsureReplaceBaseConfig} from 'meibao-insure/src/api/productCenterNew'
import FormAttach from '@/views/insuranceCenter/components/formAttach.vue'
import {EnumChannelType} from '@/util/channelUtil'

export default {
	name: 'EndorseReplace',
	components: {BaseFormDialog, FormAttach},
	data() {
		return {
			insureType: -1,
			optionEmployeeReplace: this.deepClone(optionEmployeeReplace),
			optionEmployeeEndorse: this.deepClone(optionEmployeeEndorse),
			optionEmployeeResult: this.deepClone(optionEmployeeResult),
			employeeList: [],
			employeeSelectedList: [],
			employeeReplaceList: [],
			employeeResultList: [],
			searchForm: {},
			page: {
				total: 0,
				currentPage: 1,
				pageSize: 20,
				pageSizes: [20, 50, 100, 200],
			},
			isInitLoading: true,
			listLoading: true,
			stepActive: '0',
			orderId: '',
			isNoticeRead: false,
			effectiveDate: '',
			timer: '',
			replaceSucceed: false,
			isReplaceEmp: 0,
			ReplaceContent: {
				choiceTitle: '选择被替换人员',
				choiceTi: '替换',
				fillEmp: '填写新雇员信息',
				submit: '确认替换',
			},
			isShowLoading: false,
			//不统一企业投保
			repeatEmpList: [],
			//当前被保企业
			currentRepeatUnit: '',
			allRepeatEmpList: [],
			//不同企业保险人
			replaceInfoData: {},
			//身份证校验数据
			checkIdNoData: [],
			//所有保单人员
			allEmpList: [],
			empIdNo: '',
			//是否可选上一步
			isShowStep1: true,
			fromTypeChannel: '',
			configData: {},

			//临时处理，美的合康，并且是通过账号密码登录的，则需要获取人员信息，并且填充人员remark
			remarkData: '',
		}
	},
	mixins: [huisuAble],
	computed: {
		...mapGetters(['userInfo', 'difChannelType']),
		isShowMore() {
			return isNoMoreReplace(this.insureType) && this.isShowStep1
		},
		//stepActive 获取  currentStep
		getCurrentStep() {
			return parseInt(this.stepActive)
		},
	},
	created() {
		this.init()
		this.isJudgeHuisu()
	},
	beforeDestroy() {
		//  清除定时器
		this.clearTimer()
	},
	methods: {
		async init() {
			this.isInitLoading = true
			this.orderId = this.$route.params.id
			let {
				empIdNo = '',
				isReplaceEmp = '0',
				insureType = '',
				productId = '',
				sourceProductId = '',
				isMoreReplace = '2',
			} = this.$route.query
			this.isReplaceEmp = parseInt(isReplaceEmp)
			this.insureType = parseInt(insureType)
			//处理第三方跳转进入的
			let {empIdNo: fromEmpIdNo = ''} = this.onDealFromTypeChannel()
			if (fromEmpIdNo) {
				empIdNo = fromEmpIdNo
			}
			if (this.isReplaceEmp === 1) {
				this.ReplaceContent = {
					choiceTitle: '选择修改人员',
					choiceTi: '改名',
					fillEmp: '填写雇员姓名',
					submit: '确认修改',
				}
				//不填写身份证
				this.optionEmployeeReplace.column.splice(4, 1, {
					label: '新雇员身份证',
					prop: 'idNoReplaced',
				})
			} else {
				this.ReplaceContent = {
					choiceTitle: '选择被替换人员',
					choiceTi: '替换',
					fillEmp: '填写新雇员信息',
					submit: '确认替换',
				}
			}
			try {
				//获取生效时间
				await this.getEffectiveDate(sourceProductId, productId, isMoreReplace)
				//判断是否为单一
				if (empIdNo) {
					await this.isSingleReplace(empIdNo)
				}
				//处理家电
				this.onDealJiaDianMore()
			} catch (e) {
				this.$alert(e.message || '替换数据异常！', '提示').then(() => {})
			} finally {
				this.isInitLoading = false
			}
		},
		//处理第三方跳转进入的
		onDealFromTypeChannel() {
			//再次解构，处理orderDetails
			let {fromTypeChannel = '', emp = ''} = this.$route.query
			if (fromTypeChannel !== EnumChannelType.hekang) {
				return {}
			}
			this.fromTypeChannel = fromTypeChannel
			//是否可选上一步
			this.isShowStep1 = false
			//string 转对象
			if (emp) {
				emp = JSON.parse(emp)
				//处理第三方跳转进入的
				if (emp.length === 1) {
					let {
						delEmp: {empName: delEmpName, empIdNo: delEmpIdNo} = {},
						addEmp: {empName: addEmpName, empIdNo: addEmpIdNo, remark = ''} = {},
					} = emp[0]
					return {
						empIdNo: delEmpIdNo,
						newEmpData: {
							nameNew: addEmpName,
							idNoNew: addEmpIdNo,
							remark,
						},
					}
				}
			}
			return {}
		},
		//抽离方法获取生效时间
		async getEffectiveDate(sourceProductId, productId, isMoreReplace) {
			//存在则走配置项
			if (!productId) {
				throw new Error(`参数不存在！productId：${productId}`)
			}
			//获取配置项
			let resConfig = await getInsureReplaceBaseConfig({
				operate: this.isReplaceEmp == 0 ? 3 : 4,
				batch: isMoreReplace,
				productId,
				sourceProductId,
				orderInfo: {
					orderId: this.orderId,
				},
			})
			let {code = -1, data = {}} = resConfig.data || {}
			if (code !== 0) {
				throw new Error('获取配置项失败！')
			}
			this.configData = data
			//处理期限
			let {effectTimeRange = []} = data
			//如果长度不为2，或者第一，第二不相等，则报错
			if (effectTimeRange.length != 2 || effectTimeRange[0] != effectTimeRange[1]) {
				throw new Error('生效时间数据有误,请手动刷新浏览器后，再次重试！')
			}
			//处理生效时间
			this.effectiveDate = effectTimeRange[0]
		},
		//抽离方法是否为单一传递替换
		async isSingleReplace(empIdNo) {
			this.stepActive = '1'
			//需要区分是嵌入的，还是非嵌入， 嵌入要请求数据。！！！
			let employeeReplaced = {}
			//请求数据
			let {data: {data = {}, code = -1} = {}} =
				(await fetchEmployeeListPage({orderId: this.orderId, empName: empIdNo})) || {}
			if (code !== 0) {
				this.$message.error('获取保障人员列表失败！')
				return
			}
			const {records = []} = data || {}
			if (records.length === 0) {
				throw new Error('获取保障人员有误！')
			} else if (records.length > 1) {
				//人数大于1，则提醒，并且返回 step 0
				this.$message.error('保障人员筛选失败，请重新选择！')
				this.stepActive = '0'
				return
			}
			// 嵌入的， 需要请求数据
			employeeReplaced = records[0]
			this.handleReplaceSingle(employeeReplaced, 0)
		},
		// 获取保障人员列表
		async getEmployeeList() {
			this.listLoading = true
			try {
				//page 解构
				let {currentPage: pageNo, pageSize} = this.page
				const empRes = await fetchEmployeeListPage(
					Object.assign({orderId: this.orderId}, this.searchForm, {pageNo, pageSize}),
				)
				let {data = {}, code = -1} = empRes.data || {}
				if (code !== 0) {
					this.$message.error('获取保障人员列表失败！')
					return
				}
				const {records: emps = [], total = 0} = data
				this.page.total = total
				this.employeeList = emps.map(
					({id, empName, empIdNo, category = {}, effectiveDate, expiryDate, insureMoney, priceId, remark = ''}) => {
						const {categoryName, professionLevel} = category
						// 处理日期格式
						const processDate = (date) => (date.includes('-') ? date : toYYYYmmddFullDate(date))
						//临时处理，美的合康，并且是通过账号密码登录的，则需要获取人员信息，并且填充人员remark
						if (this.onIsNeedRemark() && !this.remarkData) {
							this.remarkData = remark
						}
						return {
							id,
							empName,
							empIdNo,
							profession: categoryName ? `${categoryName} - ${professionLevel}类` : '',
							effectiveDate: processDate(effectiveDate),
							expiryDate: processDate(expiryDate),
							insureSum: `${insureMoney}万`,
							priceId,
							remark,
						}
					},
				)
			} catch (error) {
				console.error('获取员工列表失败:', error)
			} finally {
				this.listLoading = false
			}
		},

		selectionChange(list) {
			if (list && list.length > 20) {
				this.$message.error('替换人员最多替换20人！')
			}
			this.employeeSelectedList = list
		},

		searchChange(param, done) {
			if (done) {
				if (!this.validatenull(param.empIdNo)) {
					this.searchForm.empName = param.empIdNo
				} else {
					this.searchForm = param
				}
				done()
			} else {
				this.searchForm = {}
			}
			this.page.currentPage = 1
			this.getEmployeeList()
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
			this.page.currentPage = 1
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		handleStep1() {
			this.stepActive = '0'
			this.isNoticeRead = false
		},

		handleStep2() {
			this.employeeReplaceList.length = 0
			this.employeeSelectedList.forEach((item, index) => {
				var employeeSelected = {}
				employeeSelected.id = item.id
				employeeSelected.nameReplaced = item.empName
				employeeSelected.idNoReplaced = item.empIdNo
				if (!this.validatenull(item.profession)) {
					employeeSelected.profession = item.profession
				}
				employeeSelected.$cellEdit = true
				this.employeeReplaceList.push(employeeSelected)
			})
			this.stepActive = '1'
		},

		onHandleStep3Temp() {
			if (this.isReplaceEmp === 1 && this.insureType === 6) {
				this.$confirm('因保司系统升级，此次修改姓名会生成两份批单，如有疑问，请联系您的客户经理', '提示', {
					confirmButtonText: '我已知晓，继续操作',
					cancelButtonText: '取消',
				}).then((result) => {
					this.handleStep3()
				})
			} else {
				this.handleStep3()
			}
		},
		handleStep3() {
			let newEmployeeDataReady = true
			let idNoValid = true
			let idNoRepeat = false
			let map = {}
			let errIndex = -1

			this.employeeResultList.length = 0
			this.employeeReplaceList.forEach((item, index) => {
				if (this.isReplaceEmp === 1) {
					//只修改名字
					item.idNoNew = item.idNoReplaced
				}
				if (this.validatenull(item.nameNew) || this.validatenull(item.idNoNew)) {
					newEmployeeDataReady = false
				} else {
					// 过滤空格
					item.nameNew = item.nameNew.toString().replace(/\s+/g, '')
					item.idNoNew = item.idNoNew.toString().replace(/\s+/g, '')

					if (!isIdCardNoValid(item.idNoNew)) {
						idNoValid = false
						errIndex = index
					} else {
						if (map[item.idNoNew]) {
							idNoRepeat = true
						} else {
							map[item.idNoNew] = true
						}
					}
				}
				var employeeResult = {}
				employeeResult.id = item.id
				employeeResult.nameReplaced = item.nameReplaced
				employeeResult.idNoReplaced = item.idNoReplaced

				employeeResult.nameNew = item.nameNew
				employeeResult.idNoNew = item.idNoNew
				if (!this.validatenull(item.profession)) {
					employeeResult.profession = item.profession
				}
				employeeResult.effectiveDate = this.effectiveDate
				employeeResult.status = '100'

				this.employeeResultList.push(employeeResult)
			})
			if (!newEmployeeDataReady) {
				this.$alert('请完善雇员信息!', '提示', {
					confirmButtonText: '确定',
				})
				return
			}
			if (!idNoValid) {
				this.$alert(`序号${errIndex + 1}身份证号不正确`, '提示', {
					confirmButtonText: '确定',
				})
				return
			}
			if (idNoRepeat) {
				this.$alert('身份证号重复', '提示', {
					confirmButtonText: '确定',
				})
				return
			}
			//请求替换
			this.replaceEmpMe()
		},
		//请求数据
		replaceEmpMe(checkOtherRepeat = '') {
			this.isShowLoading = true
			//只设置一次
			if (checkOtherRepeat === '') {
				this.replaceInfoData = {}
				this.checkIdNoData = []
				this.replaceInfoData.orderId = this.orderId
				let empTemp = []
				this.employeeResultList.forEach((item, index) => {
					//解构
					let {id, nameNew, idNoNew, nameReplaced, idNoReplaced, profession, remark = ''} = item
					let emp = {}
					emp.sn = index + 1
					let addEmp = {}
					addEmp.empName = nameNew
					addEmp.empIdNo = idNoNew

					if (remark) {
						addEmp.remark = remark
					} else {
						//临时处理，美的合康，并且是通过账号密码登录的，则需要获取人员信息，并且填充人员remark
						if (this.onIsNeedRemark() && this.remarkData) {
							addEmp.remark = this.remarkData
						}
					}

					emp.addEmp = addEmp
					let delEmp = {}
					delEmp.empName = nameReplaced
					delEmp.empIdNo = idNoReplaced
					delEmp.id = id
					if (!this.validatenull(profession)) {
						delEmp.category = profession
					}
					emp.delEmp = delEmp
					empTemp.push(emp)
					this.checkIdNoData.push({
						name: nameNew,
						idno: idNoNew,
					})
				})
				this.replaceInfoData.emps = empTemp
			}
			this.replaceInfoData.checkOtherRepeat = checkOtherRepeat
			if (this.validatenull(this.effectiveDate)) {
				this.$alert('生效时间数据有误,请手动刷新浏览器后，再次重试！', '提示').then(() => {})
				this.isShowLoading = false
				return
			}
			//处理身份证校验！！
			//身份证都填写，开始校验
			checkIdNo(this.checkIdNoData)
				.then((resData) => {
					//处理校验数据
					let {data = [], code = -1} = resData.data
					if (code === 0) {
						let checkNoResult = ''
						for (let {name, idno, result} of data) {
							if (result === 1) {
								checkNoResult += `姓名：${name} 身份证：${idno}  ，`
							}
						}
						//韦锋账号不校验
						if (checkNoResult !== '' && this.userInfo.phone !== '18752004865') {
							this.$alert(`${checkNoResult} 校验不通过！`, '提示').then(() => {})
							this.isShowLoading = false
						} else {
							//成功
							this.onReplaceRequest()
						}
					}
				})
				.catch(() => {})
		},
		//请求替换
		onReplaceRequest() {
			//清除循环
			this.clearTimer()
			//clone this.replaceInfoData
			let replaceInfoData = this.deepClone(this.replaceInfoData)
			replaceInfoData.effectiveDate = this.effectiveDate
			//处理附件，先判断组件是否存在，然后获取数据
			let refAttach = this.$refs.refAttach
			if (refAttach) {
				let tempAttach = refAttach.getAttachData()
				if (!tempAttach) {
					this.$message.error('请上传附件！')
					this.isShowLoading = false
					return
				}
				replaceInfoData.attachInfo = tempAttach
				// Object.assign(replaceInfoData, tempAttach)
			}
			endorseReplace(replaceInfoData)
				.then((response) => {
					//数据处理
					let {code, data, originCode, msg} = response.data
					if (code !== 0) {
						let titleTemp = ''
						let hintTemp = ''
						if (originCode === '400') {
							//数据验证不通过
							if (data) {
								titleTemp = '数据校验不通过'
								data.emps.forEach((itemData) => {
									hintTemp += `${itemData.msg}</br>`
								})
							}
						} else if (originCode === '405') {
							//非同一企业重复投保人员列表
							this.currentRepeatUnit = data || ''
							//判断为对象
							if (
								this.currentRepeatUnit &&
								typeof this.currentRepeatUnit === 'object' &&
								this.currentRepeatUnit.payOrderId
							) {
								//您之前提交的新增人员申请还未支付保费
								titleTemp = '提示'
								hintTemp = msg
							} else {
								//非同一企业重复投保人员列表
								this.showRepeatEmpList()
							}
						} else if (originCode === '500') {
							//重复投保
							if (data && data instanceof Array) {
								this.allRepeatEmpList.length = 0
								this.allRepeatEmpList = data.map((itemData) => {
									return {
										empName: itemData.empName,
										empIdNo: itemData.empIdNo,
										policyNo: itemData.policyNo,
										expiryDate: itemData.expiryDate,
									}
								})
								if (this.$refs.hint_repeat) {
									this.$refs.hint_repeat.show()
								}
							}
						} else if (originCode === '503') {
							if (this.effectiveDate === data || this.validatenull(data)) {
								this.$message.error('时间数据有误!!')
								return
							}
							//如果effectiveDate为空，则需要再次请求
							if (this.validatenull(this.effectiveDate)) {
								this.effectiveDate = data
								//重新再次提交
								this.replaceEmpMe()
							}
						}
						if (!this.validatenull(hintTemp)) {
							this.$alert(hintTemp, titleTemp, {
								confirmButtonText: '确定',
								dangerouslyUseHTMLString: true,
								center: true,
							})
						}
					} else {
						this.stepActive = '2'
						this.batchId = response.data.data.batchId
						this.timer = setInterval(this.checkReplaceResult, 3000, 3000)
					}
				})
				.catch((error) => {})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//非同一企业投保
		async showRepeatEmpList() {
			// pageNo: 1
			// pageSize: 5
			// jsonEmployees: {"emp":[{"empName":"拉了","empIdNo":"411722199003073251","priceId":"288"}]}
			// jsonOrder: {"effectiveDate":"2021-11-30","expiryDate":"2022-05-18 23:59:59","id":23559}
			if (this.employeeList.length <= 0 || this.employeeReplaceList.length <= 0) {
				this.$alert('获取保单保障人员有误，请手动刷新浏览器重试！', '提示', {
					confirmButtonText: '我知道了',
				})
				return
			}
			try {
				let reqInfo = {
					pageNo: 1,
					pageSize: 20,
				}
				let jsonEmployees = {
					emp: [],
				}
				let jsonOrder = {}
				// this.prepareEmployees(jsonEmployees.emp)
				jsonEmployees.emp = this.employeeReplaceList.map(({id, nameNew, idNoNew}) => {
					let result =
						this.employeeList.find((itemEmp) => {
							return (itemEmp.id = id)
						}) || {}
					return {
						empName: nameNew,
						empIdNo: idNoNew,
						priceId: result.priceId || '',
					}
				})
				jsonOrder.effectiveDate = this.employeeList[0].effectiveDate
				jsonOrder.expiryDate = this.employeeList[0].expiryDate
				jsonOrder.id = this.orderId

				reqInfo.jsonEmployees = JSON.stringify(jsonEmployees)
				reqInfo.jsonOrder = JSON.stringify(jsonOrder)

				this.repeatEmpList.length = 0
				let resData = await getRepeatEmpList(Object.assign(reqInfo))
				let {code, data = []} = resData.data
				if (code !== 0) {
					return
				}
				//赋值
				this.repeatEmpList = data
				//展示dialog
				if (this.$refs.hint_repeat) {
					this.$refs.hint_repeat_again.show()
				}
			} catch (error) {
				this.$alert(`${error.message || '获取重复投保人员列表失败，请稍后重试！'}`, '提示', {
					confirmButtonText: '我知道了',
				})
			}
		},
		checkReplaceResult() {
			let sum = 0
			getReplaceResult(this.batchId).then((response) => {
				let emps = response.data.data.emps
				this.employeeResultList.forEach((item, index) => {
					item.status = emps[index].code
					if (item.status == 200) {
						sum = sum + 1
					}
					if (item.status == 400) {
						this.onReplaceError()
					}
				})
				if (this.employeeResultList.length == sum) {
					this.replaceSucceed = true
					this.clearTimer()
				}
			})
		},
		onReplaceError() {
			this.$alert('替换失败，如有疑问请联系客服', '提示', {
				confirmButtonText: '确定',
			})
			this.replaceSucceed = false
			this.clearTimer()
		},
		handleReplaceSingle(row = {}, index) {
			let {
				id = '',
				empName = '',
				empIdNo = '',
				profession = '',
				category: {categoryName, professionLevel} = {},
				remark = '',
			} = row
			this.employeeReplaceList.length = 0
			let employeeSelected = {}
			employeeSelected.id = id
			employeeSelected.nameReplaced = empName
			employeeSelected.idNoReplaced = empIdNo
			if (profession) {
				employeeSelected.profession = profession
			} else {
				employeeSelected.profession = `${categoryName}-${professionLevel}类`
			}
			employeeSelected.$cellEdit = true
			//处理第三方跳转进入的
			let {newEmpData = null} = this.onDealFromTypeChannel()
			if (newEmpData) {
				Object.assign(employeeSelected, newEmpData)
			}
			this.employeeReplaceList.push(employeeSelected)
			this.stepActive = '1'
			//临时处理，美的合康，并且是通过账号密码登录的，则需要获取人员信息，并且填充人员remark
			if (this.onIsNeedRemark() && !this.remarkData) {
				this.remarkData = remark
			}
		},

		handleRemoveEmployee(row, index) {
			this.employeeReplaceList.splice(index, 1)
		},

		handleGoPolicy() {
			//发送数据，或者执行
			sendMsgToParent({msgType: MessageEventType.changeSuccess, orderId: this.orderId}, () => {
				this.$router.$avueRouter.closeTag()
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/policy/details/${this.orderId}`,
					}),
				})
			})
		},
		onClickRight() {
			//同一投保人 不同企业重复投保确认
			this.replaceEmpMe('99')
		},
		//下载模板
		onDownload() {
			window.open('https://file.meibaokeji.com/assets/gz/template/template_more_reslace_new.xlsx', '_blank')
		},
		async onUploadTemp(file, fileList) {
			try {
				if (this.allEmpList.length === 0) {
					//获取所有人员
					let result = await fetchEmployeeList({orderId: this.orderId})
					let {code, data} = result.data
					if (code !== 0) {
						this.$message.error('获取保单保障人员有误，请手动刷新浏览器重试！')
						return
					}
					this.allEmpList = data.emps
				}
				this.listLoading = true
				let resData = (await exportFileCommon(file, true, 4)) || []
				//处理数据，先判断有一些人不在保单里，则提示
				console.log(resData, '-----')
				let noInHint = ''
				this.employeeReplaceList = []
				if (resData.length > 20) {
					this.$alert('替换人员一次最多替换20人！', '提示', {confirmButtonText: '知道了'}).then(() => {})
					return
				}
				for (let [data1, data2, data3, data4] of resData) {
					let empItemData = this.allEmpList.find(({empName, empIdNo}) => data1 === empName && data2 === empIdNo) || ''
					if (empItemData === '') {
						//不存在，则提示
						noInHint += ` [${data1},${data2} ] `
					} else {
						let {id, category = {}} = empItemData
						//处理人员信息
						let tempEmpData = {}
						tempEmpData.id = id
						if (!this.validatenull(category)) {
							let {categoryName, professionLevel} = category
							tempEmpData.profession = categoryName + ' - ' + professionLevel + '类'
						}
						tempEmpData.nameReplaced = data1
						tempEmpData.idNoReplaced = data2
						//替换人员
						tempEmpData.nameNew = data3
						tempEmpData.idNoNew = data4
						tempEmpData.$cellEdit = true
						//存储
						this.employeeReplaceList.push(tempEmpData)
					}
				}
				if (noInHint !== '') {
					this.$alert(`${noInHint}，该保障人员不存在，请检查后再重新导入！`, '提示', {confirmButtonText: '我知道了'})
				} else {
					this.stepActive = '1'
				}
			} catch (error) {
				this.$alert(error.message || '数据导入异常！', '提示', {confirmButtonText: '我知道了'}).then(() => {})
			} finally {
				this.listLoading = false
			}
		},
		//处理数据
		onDealList(response) {
			let tempList = []
			for (let i = 0; i < this.employeeReplaceList.length; i++) {
				let employeeReplaceTemp = this.employeeReplaceList[i]
				let tempRes = response[i]
				if (i <= response.length && tempRes) {
					employeeReplaceTemp.nameNew = tempRes[0]
					employeeReplaceTemp.idNoNew = tempRes[1]
				} else {
					employeeReplaceTemp.nameNew = ''
					employeeReplaceTemp.idNoNew = ''
				}
				tempList.push(employeeReplaceTemp)
			}
			this.employeeReplaceList = tempList
		},
		//家电不能批量替换
		onDealJiaDianMore() {
			if (isJiaDian(this.insureType)) {
				this.findObject(this.optionEmployeeEndorse.column, 'profession').hide = true
				this.findObject(this.optionEmployeeReplace.column, 'profession').hide = true
				this.findObject(this.optionEmployeeResult.column, 'profession').hide = true
			}
		},
		//清除循环
		clearTimer() {
			if (this.timer) {
				clearInterval(this.timer)
				this.timer = null
			}
		},
		/**
		 * 临时解决方案， 美的合康，并且是通过账号密码登录的，则需要获取人员信息，并且填充人员remark
		 */
		onIsNeedRemark() {
			// let {channelName = ''} = this.difChannelType || {}
			// return this.envConfig.isBxMeidiGuangfu() && !channelName
			return true
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

::v-deep .avue-crud__tip {
	height: 30px !important;
}

::v-deep .el-tabs__nav-scroll {
	height: 0;
	width: 0;
}

::v-deep .avue-crud__right .el-icon-download:after {
	color: #fff !important;
}
</style>
